import useProviderType from '@app/src/hooks/useProviderType'
import { CheckOutlined } from '@mui/icons-material'
import { Box, Chip, Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

interface TemplateTypeCardProps {
  avatar: React.ReactElement
  titleId: string
  sidetitleId?: string
  descriptionId: string
  compact?: boolean
  bulletPointIds?: string[]
  chipIds?: string[]
}

const TemplateTypeCard: React.FC<TemplateTypeCardProps> = ({
  avatar,
  titleId,
  sidetitleId,
  descriptionId,
  compact,
  bulletPointIds,
  chipIds,
}) => {
  const { formatMessage } = useIntl()
  const providerType = useProviderType()

  return (
    <Box
      sx={{
        flex: 1,
        p: compact ? 2 : 3,
        borderRadius: compact ? 1 : 2,
        border: '1px solid',
        borderColor: 'grey.300',
        bgcolor: compact ? undefined : 'grey.50',
        height: compact ? '100%' : undefined,
      }}
      role="region"
      aria-label={formatMessage({ id: titleId })}
    >
      <Stack alignItems="flex-start" p={1}>
        <Stack direction="row" alignItems="center" spacing={2}>
          {avatar}
          {sidetitleId && (
            <Typography variant="overline" color="secondary.main">
              {formatMessage({ id: sidetitleId })}
            </Typography>
          )}
        </Stack>
        <Typography variant="subtitle1" sx={{ mt: 2 }}>
          {formatMessage({ id: titleId })}
        </Typography>
        <Typography color="text.secondary" sx={{ mt: 1 }}>
          {formatMessage({ id: descriptionId }, { providerType })}
        </Typography>
        {bulletPointIds && bulletPointIds.length > 0 && (
          <Stack spacing={0.75} sx={{ mt: 1.5 }}>
            {bulletPointIds.map(id => (
              <Stack key={id} direction="row" alignItems="center" spacing={1}>
                <CheckOutlined sx={{ fontSize: 16, color: 'text.secondary' }} />
                <Typography color="text.secondary">{formatMessage({ id }, { providerType })}</Typography>
              </Stack>
            ))}
          </Stack>
        )}

        {chipIds && chipIds.length > 0 && (
          <Stack direction="row" flexWrap="wrap" gap={2} sx={{ mt: 2 }}>
            {chipIds.map(id => (
              <Chip key={id} label={formatMessage({ id })} size="medium" sx={{ borderRadius: 1 }} />
            ))}
          </Stack>
        )}
      </Stack>
    </Box>
  )
}

export default TemplateTypeCard
